// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__jYGSH","title":"InfoRow_title__3Jxi_"};